/**
 * Created by iamso on 27.10.2020
 */

const KnockoutGame = function () {
    cleverapps.EventEmitter.call(this);

    this.loseSeria = 0;
    this.winSeria = 0;
    this.lastFinishGame = 0;

    this.level = 0;

    this.load(); 
};

KnockoutGame.prototype = Object.create(cleverapps.EventEmitter.prototype);
KnockoutGame.prototype.constructor = KnockoutGame;

KnockoutGame.prototype.isRumble = function () {
    return this.rumble !== undefined;
};

KnockoutGame.prototype.wantsToPlay = function (f) {
    const isFirstLaunch = cleverapps.config.name === "differences" && levels.user.currentPhysicalLevel.episode === 0 && levels.user.currentPhysicalLevel.level === 0;

    cleverapps.focusManager.compound(f, [
        function (f) {
            if (this.isRumble() || isFirstLaunch) {
                f();
                return;
            }

            this.checkConnection(f);
        }.bind(this),

        function (f) {
            if (!this.isRumble()) {
                this.rumble = new Rumble();
            }

            if (isFirstLaunch && this.rumble.isFirstRound()) {
                cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.RUMBLE_INITIALIZE);
                this.rumble.whenInitialize((success) => {
                    if (success) {
                        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.RUMBLE_INITIALIZE_SUCCESS);
                        f();
                    } else {
                        this.onRumbleInitFailed();
                    }
                });
                return;
            }

            this.openWindow(f);
        }.bind(this)
    ]);
};

KnockoutGame.prototype.onWin = function () {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.WIN_KNOCKOUT + this.calcTournamentType());
    this.loseSeria = 0;
    this.winSeria++;
    this.lastFinishGame = Date.now();

    if (cleverapps.weeklyCup && cleverapps.weeklyCup.isAvailable()) {
        cleverapps.weeklyCup.addAmount(1);
        cleverapps.weeklyCup.reload(true);
    }
    cleverapps.eventBus.trigger("taskEvent", "PASS_KNOCKOUT");
    cleverapps.eventBus.trigger("win_knockout");
    this.save();
};

KnockoutGame.prototype.onLose = function () {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.LOSE_KNOCKOUT + this.calcTournamentType());
    this.loseSeria++;
    this.winSeria = 0;
    this.lastFinishGame = Date.now();
    this.save();
};

KnockoutGame.prototype.calcTournamentType = function () {
    let type = KnockoutGame.NORMAL_TOURNAMENT;

    if (cleverapps.user.currentPhysicalLevel.level < 2) {
        type = KnockoutGame.BOT_CANNOT_WIN_TOURNAMENT;
    } else {
        if (cleverapps.user.currentPhysicalLevel.level >= 10) {
            if (this.winSeria >= 4) {
                type = KnockoutGame.DIFFICULT_TOURNAMENT;
            }
            if (this.winSeria >= 7) {
                type = KnockoutGame.VERY_DIFFICULT_TOURNAMENT;
            }
        }

        let d = 0;
        if (this.lastFinishGame) {
            d = cleverapps.user.getDaysSinceRegistration(this.lastFinishGame);
        }
        if (d !== cleverapps.user.getDaysSinceRegistration()) {
            type = KnockoutGame.EASY_TOURNAMENT;
        }
        if (this.loseSeria > 0 || this.winSeria <= 1 || cleverapps.user.currentPhysicalLevel.level < 4) {
            type = KnockoutGame.EASY_TOURNAMENT;
        }
        if (this.loseSeria > 1) {
            type = KnockoutGame.VERY_EASY_TOURNAMENT;
        }
    }

    return type;
};

KnockoutGame.prototype.stopRumble = function () {
    delete this.rumble;
};

KnockoutGame.prototype.checkConnection = function (callback) {
    if (cleverapps.flags.nomulti) {
        callback();
        return;
    }

    cleverapps.focusManager.display({
        stack: true,
        focus: "CheckConnection",
        action: (f) => {
            cleverapps.loading.show();
            cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.KNOCKOUT_CONNECTION);

            cleverapps.RestClient.get("/", {}, () => {
                cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.KNOCKOUT_CONNECTION_SUCCESS);

                cleverapps.loading.hide();
                f();

                callback();
            }, () => {
                cleverapps.loading.hide();

                cleverapps.focusManager.distract({
                    focus: "KnockoutGameNoConnection",
                    action: function (f) {
                        new NoConnectionWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            });
        }
    });
};

KnockoutGame.prototype.onRumbleInitFailed = function () {
    this.stopRumble();

    cleverapps.focusManager.distract({
        focus: "KnockoutGameNoConnection",
        action: function (f) {
            new NoConnectionWindow();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

KnockoutGame.prototype.openWindow = function (f, options) {
    new KnockoutWindow(this.rumble, options);
    cleverapps.focusManager.onceNoWindowsListener = f;
};

KnockoutGame.prototype.getData = function () {
    return {
        knockoutLevel: this.level
    };
};

KnockoutGame.prototype.updateData = function (data) {
    let knockoutLevel;

    if (data.knockoutLevel !== undefined) {
        knockoutLevel = data.knockoutLevel;
    } else if (data.cups !== undefined) {
        knockoutLevel = data.cups;
    } else {
        knockoutLevel = cleverapps.user.getVirtualLevel() - 1;
    }

    this.setLevel(knockoutLevel);
};

KnockoutGame.prototype.getNextLevel = function () {
    const level = this.level;

    this.setLevel(this.level + 1);
    cleverapps.meta.save();

    return Level.CreateByNumber(level);
};

KnockoutGame.prototype.setLevel = function (level) {
    this.level = level;
};

KnockoutGame.prototype.getLevel = function () {
    return this.level;
};

KnockoutGame.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.KNOCKOUT) || {};
    this.loseSeria = data.loseSeria || 0;
    this.winSeria = data.winSeria || 0;
    this.lastFinishGame = data.lastFinishGame || 0;
};

KnockoutGame.prototype.save = function () {
    const data = {
        loseSeria: this.loseSeria,
        winSeria: this.winSeria,
        lastFinishGame: this.lastFinishGame
    };

    cleverapps.dataLoader.save(DataLoader.TYPES.KNOCKOUT, data);
};

KnockoutGame.prototype.reset = function () {
    this.loseSeria = 0;
    this.winSeria = 0;
    this.lastFinishGame = 0;

    this.save();

    this.setLevel(0);
};

KnockoutGame.BOT_CANNOT_WIN_TOURNAMENT = 1;
KnockoutGame.VERY_EASY_TOURNAMENT = 2;
KnockoutGame.EASY_TOURNAMENT = 3;
KnockoutGame.NORMAL_TOURNAMENT = 4;
KnockoutGame.DIFFICULT_TOURNAMENT = 5;
KnockoutGame.VERY_DIFFICULT_TOURNAMENT = 6;
